export enum InterventionStatusEnum {
  INTERVENTION_STATUS_CANCELED = 4,
  INTERVENTION_STATUS_WAITING_PROGRAMMING = 8,
  INTERVENTION_STATUS_WAITING_CONFIRMATION = 1,
  INTERVENTION_STATUS_CONFIRMED = 2,
  INTERVENTION_STATUS_BILLED = 10,
}
